import clsx from 'clsx';
import React from 'react';
import { factory } from '../../../factory/factory.utils.mjs';
import { Box } from '../../../Other/Box/Box.mjs';
import { useCarouselContext } from '../Carousel.context.mjs';
import classes from '../Carousel.module.css.mjs';

const CarouselSlide = factory((props, ref) => {
  const { className, ...rest } = props;
  const classNames = clsx(classes.slide, className);
  const ctx = useCarouselContext();
  return /* @__PURE__ */ React.createElement(Box, { ref, className: classNames, ...rest, "data-orientation": ctx.orientation });
});

export { CarouselSlide };
